// extracted by mini-css-extract-plugin
export default {"label":"RelatedItems_label__rM+EN"};